import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Admin.css';

function AdminDashboard() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    if (localStorage.getItem('adminAuth') !== 'true') {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    navigate('/admin/login');
  };

  const sections = [
    { id: 'home', name: 'Home Page', icon: 'fa-home' },
    { id: 'about', name: 'About Us', icon: 'fa-info-circle' },
    { id: 'academics', name: 'Academics', icon: 'fa-graduation-cap' },
    { id: 'facilities', name: 'Facilities', icon: 'fa-building' },
    { id: 'gallery', name: 'Gallery', icon: 'fa-images' },
    { id: 'leaders', name: 'School Cabinet', icon: 'fa-users' },
    { id: 'news', name: 'News & Events', icon: 'fa-newspaper' },
    { id: 'contact', name: 'Contact', icon: 'fa-envelope' }
  ];

  return (
    <div style={{display: 'flex', minHeight: '100vh', background: '#f5f5f5', flexDirection: window.innerWidth <= 768 ? 'column' : 'row'}}>
      {/* Sidebar */}
      <div style={{width: window.innerWidth <= 768 ? '100%' : '250px', background: '#1e3a8a', color: 'white', padding: '20px'}}>
        <h2 style={{color: 'white', marginBottom: '30px', textAlign: 'center'}}>Admin Panel</h2>
        <ul style={{listStyle: 'none', padding: 0}}>
          {sections.map(section => (
            <li key={section.id} style={{marginBottom: '10px'}}>
              <button
                onClick={() => setActiveSection(section.id)}
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  background: activeSection === section.id ? '#2563eb' : 'transparent',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: 600
                }}
              >
                <i className={`fas ${section.icon}`} style={{marginRight: '10px'}}></i>
                {section.name}
              </button>
            </li>
          ))}
        </ul>
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '12px',
            background: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            marginTop: '30px',
            cursor: 'pointer',
            fontWeight: 600
          }}
        >
          <i className="fas fa-sign-out-alt" style={{marginRight: '10px'}}></i>
          Logout
        </button>
      </div>

      {/* Main Content */}
      <div style={{flex: 1, padding: window.innerWidth <= 768 ? '15px' : '30px'}}>
        <div style={{background: 'white', padding: window.innerWidth <= 768 ? '20px' : '30px', borderRadius: '15px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}}>
          <h2 style={{marginBottom: '30px', color: '#1e3a8a'}}>
            Edit {sections.find(s => s.id === activeSection)?.name}
          </h2>

          {/* Content Editor */}
          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: 600}}>Section Title</label>
            <input
              type="text"
              placeholder="Enter section title"
              style={{width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '1rem'}}
            />
          </div>

          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: 600}}>Content</label>
            <textarea
              placeholder="Enter content"
              rows="6"
              style={{width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '1rem', fontFamily: 'inherit'}}
            />
          </div>

          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '8px', fontWeight: 600}}>Upload Image</label>
            <input
              type="file"
              accept="image/svg+xml,image/jpeg,image/jpg"
              style={{width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: '8px'}}
            />
          </div>

          <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
            <button style={{padding: '12px 30px', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer'}}>
              <i className="fas fa-save" style={{marginRight: '8px'}}></i>
              Save Changes
            </button>
            <button style={{padding: '12px 30px', background: '#6b7280', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer'}}>
              <i className="fas fa-eye" style={{marginRight: '8px'}}></i>
              Preview
            </button>
          </div>

          {/* Info Box */}
          <div style={{marginTop: '30px', padding: '20px', background: '#fef3c7', borderRadius: '10px', border: '2px solid #fbbf24'}}>
            <p style={{margin: 0, color: '#92400e'}}>
              <i className="fas fa-info-circle" style={{marginRight: '8px'}}></i>
              <strong>Note:</strong> This is a basic admin interface. For production use, implement proper backend API integration, database storage, and authentication.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
